<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mt-0 mb-1">{{ $t('experience_level.form.information') }}</h4>
          <p class="sub-header"></p>

          <div class="row">

            <div class="col-12">

              <div class="form-group">
                <label for="" class="form-label">{{$t('experience_level.form.name.label')}}</label>
                <input 
                  type="text" 
                  readonly="" 
                  class="form-control-plaintext"
                  v-model="model.name"
                >
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      model:{ },
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    experienceLevelID() {
      let parameters = this.parameters || {}
      return parameters.experienceLevelID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.experienceLevelID

      return this.$store.dispatch('experience_level/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
        }
      })
    }
  },
  watch: {
    experienceLevelID: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()
    }
  },
  mounted() {
    if (this.experienceLevelID) {
      this.fetchData()
    }
  }
}
</script>